import * as yup from 'yup';

import { leistungsumfangSchema } from '@/features/Sparten/woh/schema/leistungsumfangSchema/leistungsumfangSchema';
import { ableitungsrohreSchema } from '@/features/Sparten/woh/schema/ableitungsrohreSchema/ableitungsrohreSchema';
import { sanierungenSchema } from '@/features/Sparten/woh/schema/sanierungenSchema/sanierungenSchema';
import { vorschaedenSchema } from '@/features/Sparten/woh/schema/vorschaedenSchema/vorschaedenSchema';
import { getNextDay, getNextYear } from '@/utils/dates/dates';
import { photovoltaikSchema } from '@/features/Sparten/woh/schema/photovoltaikSchema/photovoltaikSchema';
import {
  hasDachgeschoss,
  isMehrfamilienhaus,
} from '@/features/Sparten/woh/formConfigs/sharedRenderConditions';
import { addYears } from 'date-fns';
import { weitereAusstattungSchema } from '@/features/Sparten/woh/schema/weitereAusstattungSchema/weitereAusstattungSchema';

export const wohSchema = yup.object({
  plz: yup
    .string()
    .default('')
    .max(5, 'Bitte geben Sie eine gültige Postleitzahl ein')
    .required(),
  ort: yup.string().default('').required(),
  strasse: yup.string().default('').required(),
  hausnummer: yup.string().default('').required(),

  tarifgruppe: yup.string().default(''),
  gebaeudeart: yup.string().default(''),
  gebaeudetyp: yup.string().default(''),
  wohneinheiten: yup
    .number()
    .default(3)
    .when({
      is: () => isMehrfamilienhaus(),
      then: yup.number().required().min(3).max(5),
    }),
  baujahr: yup
    .number()
    .default(0)
    .min(1800)
    .max(getNextYear(addYears(new Date(), 1)).getFullYear()), // + 2 Years
  bauartklasse: yup.string().default(''),
  vollgeschosse: yup.number().default(1).min(1).max(6),
  garagen: yup.number().default(0).min(0).max(5),
  carports: yup.number().default(0).min(0).max(5),
  wohnflaeche: yup
    .number()
    .default(0)
    .max(500, 'Es sind maximal 500m² erlaubt.')
    .notOneOf([0])
    .required(),
  keller: yup.boolean().default(false),
  kellerWohnflaeche: yup
    .number()
    .default(0)
    .max(500, 'Es sind maximal 500m² erlaubt.'),
  dachgeschoss: yup.string().default(''),
  dachgeschossWohnflaeche: yup
    .number()
    .default(0)
    .max(500, 'Es sind maximal 500m² erlaubt.')
    .when({
      is: () => hasDachgeschoss(),
      then: yup.number().required().notOneOf([0]),
    }),

  fussbodenheizung: yup.boolean().default(false),
  klimaanlage: yup.boolean().default(false),
  schwimmbad: yup.boolean().default(false),
  solaranlage: yup.boolean().default(false),
  waermepumpe: yup.boolean().default(false),
  sauna: yup.boolean().default(false),
  kachelofen: yup.boolean().default(false),
  wintergarten: yup.boolean().default(false),
  photovoltaikVorhanden: yup.boolean().default(false),
  weitereAusstattung: weitereAusstattungSchema,

  versicherungssumme: yup
    .number()
    .default(0)
    .when('nutzeWert1914', {
      is: (val: boolean) => !val,
      then: yup.number().required().notOneOf([0]),
    }),
  wert1914: yup
    .number()
    .default(0)
    .when('nutzeWert1914', {
      is: (val: boolean) => val,
      then: yup.number().required().notOneOf([0]),
    }),
  nutzeWert1914: yup.boolean().required().default(true),

  versicherungsbeginn: yup.date().nullable().required().default(getNextDay()),
  selbstbeteiligung: yup.string().required().default(''),
  laufzeit: yup.string().required().default(''),
  zahlweise: yup.string().required().default(''),

  absicherungen: leistungsumfangSchema,
  ableitungsrohre: ableitungsrohreSchema,
  photovoltaik: photovoltaikSchema,

  vorversicherung: yup.string().default('unbekannt'),
  demvRabattiert: yup.boolean().default(true),
  sanierung: yup.boolean().default(false),
  sanierungen: sanierungenSchema,
  vorschaden: yup.boolean().default(false),
  vorschaeden: vorschaedenSchema,

  temporaryInputFields: yup.object({
    hasZuersError: yup.boolean().default(false),
    zuersZoneConfirmed: yup
      .boolean()
      .default(false)
      .when('hasZuersError', {
        is: (val: boolean) => val,
        then: yup.boolean().notOneOf([false]),
      }),
    updateClientAddress: yup.boolean().default(false),
  }),
});
